import React from 'react';
import { createStructuredSelector } from 'reselect';
import connect from 'react-redux/es/connect/connect';
import { bindActionCreators } from 'redux';
import { useLocation } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import compose from 'ramda/es/compose';
import { Navigation } from './navigation.component';
import {
  selectMenuContentType,
  selectMenuEntryId,
  selectIsCategoryMenuVisible,
  selectHeaderStyle,
  selectMenuOpened,
} from '../../reducers/menu/menu.selectors';
import { selectLogo, selectLogoMobile } from '../../reducers/config/config.selectors';
import { MenuActions } from '../../reducers/menu/menu.redux';

const mapStateToProps = createStructuredSelector({
  contentType: selectMenuContentType,
  entryId: selectMenuEntryId,
  headerStyle: selectHeaderStyle,
  isOpened: selectMenuOpened,
  isCategoryMenuVisible: selectIsCategoryMenuVisible,
  logo: selectLogo,
  logoMobile: selectLogoMobile,
});

export const mapDispatchToProps = (dispatch) => bindActionCreators({
  setMenuOpened: MenuActions.setMenuOpened,
}, dispatch);

const Connected = compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(Navigation);

export default props => {
  const routerLocation = useLocation();
  return <Connected {...props} location={routerLocation} />;
};
